import React, { useEffect } from 'react';
import './ShippingPolicy.css';

const ShippingPolicy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="policy-container">
      <div className="policy-hero shipping-hero">
        <div className="policy-overlay">
          <h1>Shipping, Refund & Replacement Policy</h1>
          <p>Our commitment to quick delivery and quality assurance</p>
        </div>
      </div>

      <div className="policy-content">
        <div className="policy-header">
          <div className="company-unit">
            <p>A unit of NexSpyder Technologies Pvt. Ltd.</p>
          </div>
        </div>

        <div className="policy-introduction">
          <p>
            At Procart India we want your parts, projects and prototypes to arrive quickly, safely and
            exactly as expected. To achieve this we ship only through trusted courier partners and apply
            the same maker-grade care to our customer service that we put into our own builds.
          </p>
        </div>

        <div className="policy-sections-container">
          <div className="policy-section with-icon">
            <div className=" shipping-icon">
              <i className="fas fa-truck"></i>
            </div>
            <div className="section-details">
              <h2>Shipping and Delivery</h2>
              <div className="section-content">
                <p>
                  Orders placed before 1:30 pm on working days (Monday – Saturday, excluding public
                  holidays) are normally handed to our courier the same day. Lightning-Delivery–eligible
                  Bangalore pin codes receive their parcels the same evening between 3 pm and 10 pm. All
                  other domestic shipments typically reach you within two to five working days, but please
                  allow for the occasional courier delay that is outside our control. We always ship with a tax
                  invoice inside the package as required by Indian regulations. Real-time tracking is available
                  through the "Track Your Order" link in your Procart account.
                </p>
              </div>
            </div>
          </div>

          <div className="policy-section with-icon">
            <div className=" packaging-icon">
              <i className="fas fa-box"></i>
            </div>
            <div className="section-details">
              <h2>Packaging and Receipt</h2>
              <div className="section-content">
                <p>
                  Every order is sealed in Procart-branded packaging. If the outer carton shows signs of
                  tampering or damage, please refuse the delivery and call our support desk
                  on +91-XXXXXXXXXX with your order reference so we can dispatch a replacement
                  immediately.
                </p>
              </div>
            </div>
          </div>

          <div className="policy-section with-icon">
            <div className=" courier-icon">
              <i className="fas fa-shipping-fast"></i>
            </div>
            <div className="section-details">
              <h2>Courier Partners</h2>
              <div className="section-content">
                <p>
                  We currently dispatch through FedEx and Aramex; the checkout page will display the
                  available option for your pin code. For very remote areas we can, on request, attempt EMS
                  Speed Post, although acceptance is subject to postal inspection and cannot be guaranteed.
                </p>
              </div>
            </div>
          </div>

          <div className="policy-section with-icon">
            <div className=" warranty-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <div className="section-details">
              <h2>Warranty and Quality Assurance</h2>
              <div className="section-content">
                <p>
                  All items ship with the manufacturer's or Procart's standard warranty unless a different term
                  is stated on the product page. Warranty covers manufacturing defects only. It does not
                  extend to parts that have been soldered, modified, mis-wired, subjected to static discharge,
                  mechanical stress or any other form of misuse.
                </p>
              </div>
            </div>
          </div>

          <div className="policy-section with-icon">
            <div className=" doa-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <div className="section-details">
              <h2>Dead-on-arrival, Missing or Wrong Items</h2>
              <div className="section-content">
                <p>
                  If something in your parcel is damaged, missing or not what you ordered, raise a support
                  ticket from the website within two calendar days of delivery and attach clear photos of the
                  item and the packaging. Our technical team will issue an RMA number and arrange a prepaid
                  pickup. Once the return is inspected we will ship a free replacement at our cost; if the item is
                  no longer in stock we will process a full refund to your original payment method.
                </p>
              </div>
            </div>
          </div>

          <div className="policy-section with-icon">
            <div className=" returns-icon">
              <i className="fas fa-exchange-alt"></i>
            </div>
            <div className="section-details">
              <h2>Returns for Repair or Replacement</h2>
              <div className="section-content">
                <p>
                  If a product develops a fault within its warranty period and remote troubleshooting does not
                  resolve the issue, we will authorise a return. Write the RMA number clearly on the outer
                  shipping box; please do not mark the product's own retail packaging. Verified defective
                  items are repaired or replaced and dispatched back to you within two working days of arrival
                  at our service desk. If a like-for-like replacement is unavailable you may choose an
                  equivalent item or receive a 100 percent refund.
                </p>
                <p>
                  If you receive a product that is damaged, defective, missing, or incorrect, you must email us at 
                  support@procartindia.com within 2 calendar days of delivery. Please include:
                </p>
                <ul className="policy-list">
                  <li>Your Order ID</li>
                  <li>Clear photos of the product, outer packaging, and invoice</li>
                  <li>A short description of the issue</li>
                </ul>
                <p>
                  Our technical support team will verify the issue and, if applicable, issue a Return
                  Merchandise Authorization (RMA) Number. Only after this verification will we initiate the
                  pickup, replacement, or refund process.
                </p>
                <p>Please note:</p>
                <ul className="policy-list">
                  <li>No returns will be accepted without prior approval and an RMA Number.</li>
                  <li>The RMA Number must be clearly mentioned on the outer shipping box (not on the
                  product packaging).</li>
                  <li>If the item is verified as faulty and cannot be replaced due to stock unavailability, a
                  100% refund will be issued.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="policy-section with-icon">
            <div className=" cancel-icon">
              <i className="fas fa-ban"></i>
            </div>
            <div className="section-details">
              <h2>Order Cancellation</h2>
              <div className="section-content">
                <p>
                  You may request cancellation by email as long as the order status is still "Pending" or
                  "Payment Verification." Once an order is packed or handed to the courier it can no longer be
                  cancelled. Gateway providers charge us even on reversed transactions; therefore, cancelled
                  orders may attract up to a five-percent fee to cover non-refundable bank charges. Because
                  we deal in electro-static-sensitive devices and maintain strict outgoing-quality procedures
                  we cannot accept change-of-mind returns.
                </p>
              </div>
            </div>
          </div>

          <div className="policy-section with-icon">
            <div className=" limits-icon">
              <i className="fas fa-info-circle"></i>
            </div>
            <div className="section-details">
              <h2>Limits of Responsibility</h2>
              <div className="section-content">
                <p>
                  Procart India cannot be held liable for damage caused by incorrect wiring, polarity reversal,
                  over-voltage, firmware errors, improper mechanical mounting or any installation that does
                  not follow the component's datasheet. Always observe ESD precautions, voltage limits and
                  safety guidelines when integrating electronic parts.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="policy-conclusion">
          <p>
            By placing an order with Procart India you acknowledge that you have read, understood and
            agreed to the terms above. Our goal is to keep you building, so if anything, here is unclear or
            you need help with a shipment, just reach out to support@procart.in or call our
            customer-care line and we'll sort it out as fast as we deliver our components.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;